import { Feedback } from '@chegg-wt/core/types/paraphraser'
import { SentenceOffset } from '@chegg-wt/core/state/paraphraser/types'
import type { Step } from '@tiptap/pm/transform'

export enum HistoryDeltaAction {
  APPLY = 'APPLY',
  DISCARD = 'DISCARD',
}
export enum HistoryChangeType {
  APPLY_GRAMMAR = 'APPLY_GRAMMAR',
  APPLY_PARAPHRASE = 'APPLY_PARAPHRASE',
  APPLY_QUICK_ACTION = 'APPLY_QUICK_ACTION',
  MANUAL_CHANGE = 'MANUAL_CHANGE',
  DISCARD_FEEDBACK = 'DISCARD_FEEDBACK',
}

export interface FeedbackDelta {
  feedback: Feedback
  action: HistoryDeltaAction
}

interface SentencesDelta {
  sentence: Omit<SentenceOffset, 'originalText' | 'lastUpdated'>
}

export interface HistoryCurrentVersion {
  removedGrammarFeedbacks: Set<String>
  removedParaphraseFeedbacks: Set<String>
  addedGrammarFeedbacks: Set<String>
  addedParaphraseFeedbacks: Set<String>
  steps: Step[]
  feedbackDelta: FeedbackDelta[]
  sentencesDelta: SentencesDelta[]
  changeType: HistoryChangeType
  enableReviewButton?: boolean
}

export interface HistoryVersion extends Omit<HistoryCurrentVersion, 'steps'> {
  stepsJson: JSON[]
}
